<template>
    <div class="main-content">
        <div id="dynamicPriceList">
            <h1>PRICE PORTAL:</h1>
            <span>Customer Price List Creation</span><br>
            <em>Pricing information is refreshed nightly. For the most accurate price list or report, please download after 9AM EST.</em>
            <br><br>
            <div>
                <strong>SEARCH CUSTOMER:</strong><br>
                <form @submit.prevent="searchCustomerPriceList">
                    <Autocomplete
                        :source="customers"
                        placeholder="Enter Customer..."
                        @selected="selectCustomer"
                        style="width:25vw;display:inline-block;">
                    </Autocomplete>
                    <button class="btn-round-red" type="submit">GO ></button>
                </form>
            </div>
            <br>
            <div>
                <h2>QUICK LINKS</h2>
                <strong>RETAIL (NO DEVIATIONS)</strong>
                <ul style="margin-left:20px;">
                    <li>
                        <router-link :to="{ name: 'PriceListPortal', params: { customerId: 'WC-LIST' } }" id="priceListQuickLink">
                            LIST
                        </router-link>
                    </li>
                    <li>
                        <router-link :to="{ name: 'PriceListPortal', params: { customerId: 'WC-SW5' } }" id="priceListQuickLink">
                            SW5 + LIST
                        </router-link>
                    </li>
                    <li>
                        <router-link :to="{ name: 'PriceListPortal', params: { customerId: 'WC-SW10' } }" id="priceListQuickLink">
                            SW10 + LIST
                        </router-link>
                    </li>
                    <li>
                        <router-link :to="{ name: 'PriceListPortal', params: { customerId: 'WC-SW15' } }" id="priceListQuickLink">
                            SW15 + LIST
                        </router-link>
                    </li>
                    <li>
                        <router-link :to="{ name: 'PriceListPortal', params: { customerId: 'WC-SW20' } }" id="priceListQuickLink">
                            SW20 + LIST
                        </router-link>
                    </li>
                    <!-- <li>
                        <router-link :to="{ name: 'PriceListPortal', params: { customerId: 'PIPRETCO' } }" id="priceListQuickLink">
                            CLOSEOUT
                        </router-link>
                    </li> -->
                    <li>
                        <router-link :to="{ name: 'PriceListPortal', params: { customerId: 'PUMA' } }" id="priceListQuickLink">
                            PUMA
                        </router-link>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex";
import Autocomplete from "vuejs-auto-complete";
export default {
    components: {
        Autocomplete
    },
    data() {
        return {
            customers: [],
            selectedCustomer: ''
        }
    },
    computed: {
        ...mapState([
            "user",
        ])
    },
    created() {
        axios.get(`/api/getCompaniesForAutoComplete`).then(response => {
            this.customers = response.data;
        });
    },
    methods: {
        selectCustomer(result) {
            this.selectedCustomer = result.value;
        },
        searchCustomerPriceList() {
            this.$router.push({
                name: "PriceListPortal",
                params: { customerId: this.selectedCustomer }
            });
        }
    }
}
</script>

<style scoped>
#priceListQuickLink {
    color: #000;
    text-decoration: underline;
}
</style>